// extracted by mini-css-extract-plugin
module.exports = {"ShareArticle":"ShareArticle_ShareArticle__TjUqm","icons":"ShareArticle_icons__Ri5A4"};